"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineAutocompleteCellFactory = void 0;
const react_1 = __importStar(require("react"));
const form_autocomplete_1 = require("../../../composite/form/fields/form-autocomplete");
function useInlineAutocompleteCellFactory({ dataHook, collectionDatakey, isSubkey = true, multiple, disabled, notifyChange, labelMapper, }) {
    return react_1.useMemo(() => function InlineAutocompleteCell({ index, column, }) {
        const source = dataHook();
        return (react_1.default.createElement(form_autocomplete_1.FormAutocomplete, { name: isSubkey
                ? `${collectionDatakey}[${index}].${column.datakey}`
                : `${collectionDatakey}[${index}]`, source: source, multiple: multiple, labelOptions: { hide: true }, layoutOptions: { noUnderline: true }, disabled: typeof disabled === 'function' ? disabled(index) : disabled, labelMapper: labelMapper, notifyChange: notifyChange }));
    }, [
        collectionDatakey,
        dataHook,
        isSubkey,
        multiple,
        disabled,
        labelMapper,
        notifyChange,
    ]);
}
exports.useInlineAutocompleteCellFactory = useInlineAutocompleteCellFactory;
//# sourceMappingURL=inline-autocomplete-cell.js.map